import { avatar } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'avatar',
  label: 'Avatar',
  category: 'Data Display',
  image: avatar
};
